var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19963 2.19963C8.64752 2.19963 8.19994 2.6472 8.19994 3.19932V3.99907C8.19994 5.893 6.81396 7.46323 5.00093 7.75081V11.9966C5.00093 12.9904 5.80657 13.796 6.80037 13.796H12.3986C12.4156 13.796 12.4326 13.7968 12.4495 13.7982C12.7129 13.8206 13.2012 13.5556 13.412 12.6686L14.1967 8.74499C14.1694 8.21732 13.7329 7.79789 13.1984 7.79789H10.7991C10.4679 7.79789 10.1993 7.52935 10.1993 7.19808V3.19932C10.1993 2.6472 9.75174 2.19963 9.19963 2.19963ZM4.83342 14.2606C5.35998 14.7185 6.0478 14.9957 6.80037 14.9957H12.3757C13.5188 15.0753 14.3213 14.0457 14.5821 12.9332C14.5836 12.9268 14.585 12.9204 14.5863 12.914L15.3861 8.91522C15.3938 8.87648 15.3977 8.83708 15.3977 8.79758C15.3977 7.58293 14.413 6.59826 13.1984 6.59826H11.3989V3.19932C11.3989 1.98467 10.4143 1 9.19963 1C7.98498 1 7.00031 1.98467 7.00031 3.19932V3.99907C7.00031 5.43457 5.83661 6.59826 4.40112 6.59826H2.00186C1.2289 6.59826 0.602295 7.22487 0.602295 7.99783V13.5961C0.602295 14.3691 1.2289 14.9957 2.00186 14.9957H3.60137C4.13383 14.9957 4.59684 14.6983 4.83342 14.2606ZM3.8013 7.79789H2.00186C1.89144 7.79789 1.80192 7.88741 1.80192 7.99783V13.5961C1.80192 13.7065 1.89144 13.796 2.00186 13.796H3.60137C3.71179 13.796 3.8013 13.7065 3.8013 13.5961V7.79789Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutcome);
export default __webpack_public_path__ + "static/media/like_outcome.6932e3acf1dcc75e74ddaa23ec86e57e.svg";
export { ForwardRef as ReactComponent };